import { render, staticRenderFns } from "./Laws.vue?vue&type=template&id=4f5055cb&scoped=true"
import script from "./Laws.vue?vue&type=script&lang=js"
export * from "./Laws.vue?vue&type=script&lang=js"
import style0 from "./Laws.vue?vue&type=style&index=0&id=4f5055cb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5055cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f5055cb')) {
      api.createRecord('4f5055cb', component.options)
    } else {
      api.reload('4f5055cb', component.options)
    }
    module.hot.accept("./Laws.vue?vue&type=template&id=4f5055cb&scoped=true", function () {
      api.rerender('4f5055cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Laws.vue"
export default component.exports